import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { usePagination } from 'react-table'
import { toast } from 'react-toastify'
import { ResponsesServices } from 'Services/responsesServices'
import Index from './Log/Index'

const LogsIndex = () => {

  
  return (
    <Index />
  )
}

export default LogsIndex




